import { z } from 'zod'

import { ensureRouteData, prefetchRouteData } from '@/app/query-client'
import { cycleMapQueryOptions, signalSessionsQueryOptions } from '@/features/signals/api/queries'
import type { RouterContext } from '@/routes/layouts/root'
import {
  cycleGroupingParamSchema,
  cycleYearsParamSchema,
  sessionDateParamSchema,
} from '@/screens/signals/search'

/**
 * - `by` — By month or By quarter.
 * - `years` — 1–10 BS years (5).
 * - `date` — the picker's. The map ignores it, so a past one only turns the page to its no-data
 *   state (`asks/signals-dates.md`).
 */
export const cycleMapSearchSchema = z.object({
  date: sessionDateParamSchema,
  by: cycleGroupingParamSchema,
  years: cycleYearsParamSchema,
})

/** The `/market/signals/cycle-map` loader. MAIN: the entry URL's map. */
export async function loadCycleMap({
  context: { queryClient },
  location,
  preload,
}: {
  context: RouterContext
  location: { search: unknown }
  preload: boolean
}): Promise<void> {
  const { by, years } = cycleMapSearchSchema.parse(location.search)
  if (!preload) prefetchRouteData(queryClient, signalSessionsQueryOptions())
  await ensureRouteData(queryClient, cycleMapQueryOptions({ by, years }))
}
